import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { useAppDispatch, useAppSelector } from "../../../../reduxToolkit/hooks";
import { setSignUpModal } from "../../../../reduxToolkit/reducers/layoutSlice";
import CloseBtn from "../../../commonComponents/CloseBtn";
import SignUpForm from "../common/SignUpForm";

const SignUpModal = () => {
  const { signUpModal } = useAppSelector((state) => state.layout);
  const dispatch = useAppDispatch();

  const toggle = () => dispatch(setSignUpModal());

  return (
    <Modal centered fade modalClassName="theme-modal" isOpen={signUpModal} toggle={toggle}>
      <ModalHeader toggle={toggle} close={<CloseBtn toggle={toggle} />} />
      <ModalBody>
        <SignUpForm />
      </ModalBody>
    </Modal>
  );
};

export default SignUpModal;
